import React from 'react';
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getSignedIdStatus, decode_utf8 } from "../../../common/utils/utilsFunc";


export const ElectrodependentContext = React.createContext();

export const ACTIONS = {
    SET_LOAD_PAGE: "SET_LOAD_PAGE",
    SET_ERROR: "SET_ERROR",
    SET_IDCLIENT: "SET_IDCLIENT",
    SET_NEWIDCLIENT: "SET_NEWIDCLIENT",
    SET_IDCLIENT_AUX: "SET_IDCLIENT_AUX",
    SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
    SET_NEW_DETAIL_CLIENT: "SET_NEW_DETAIL_CLIENT",
    SET_ALL_REGION: "SET_ALL_REGION",
    SET_ALL_TYPE_ELECTRODEPENDIENTES: "SET_ALL_TYPE_ELECTRODEPENDIENTES",
    SET_ID_REGION: "SET_ID_REGION",
    SET_COMUNA_REGION: "SET_COMUNA_REGION",
    SET_COMUNA: "SET_COMUNA",
    SET_WEB_CONTENT_TERMS: "SET_WEB_CONTENT_TERMS",
    SET_JSON_FORMS: "SET_JSON_FORMS",
    SET_JSON_FORMSRE: "SET_JSON_FORMSRE",
    SET_JSON_FORMSBA: "SET_JSON_FORMSBA",
    SET_JSON_FORMSCD: "SET_JSON_FORMSCD",
    SET_RESPONSE_FORMS: "SET_RESPONSE_FORMS",
    SET_RESPONSE_FORMSRE: "SET_RESPONSE_FORMSRE",
    SET_RESPONSE_FORMSBA: "SET_RESPONSE_FORMSBA",
    SET_RESPONSE_FORMSCD: "SET_RESPONSE_FORMSCD",
    SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
    SET_ESTADO_SOLICITUD: "SET_ESTADO_SOLICITUD",
    SET_SOLICITUDED: "SET_SOLICITUDED",
    SET_EQUIPOS: "SET_EQUIPOS",
    SET_FECHA_SOLICITUD: "SET_FECHA_SOLICITUD",
    SET_RUT: "SET_RUT",

};

const initialState = {
    loadPage: false,
    idClient: null,
    newIdClient: null,
    rutPatient: null,
    idClientAux: null,
    detailClient: null,
    newDetailClient: null,
    errorFetch: null,
    allRegion: null,
    allTypelectrodependientes: null,
    idRegion: null,
    comunaRegion: null,
    comuna: null,
    webContentTerm: null,
    jsonForms: null,
    jsonFormsRe: null,
    jsonFormsBa: null,
    jsonFormsCd: null,
    responseForms: null,
    responseFormsRe: null,
    responseFormsBa: null,
    responseFormsCd: null,
    webContentTextInfo: "",
};

const ElectrodependentReducer = (state = initialState, action) => {

    switch (action.type) {
        case ACTIONS.SET_LOAD_PAGE: {
            return {
                ...state,
                loadPage: action.payload
            };
        }
        case ACTIONS.SET_IDCLIENT: {
            return {
                ...state,
                idClient: action.payload
            };
        }
        case ACTIONS.SET_NEWIDCLIENT: {
            return {
                ...state,
                newIdClient: action.payload
            };
        }
        case ACTIONS.SET_RUT: {
            return {
                ...state,
                rutPatient: action.payload
            };
        }
        case ACTIONS.SET_IDCLIENT_AUX: {
            return {
                ...state,
                idClientAux: action.payload
            };
        }
        case ACTIONS.SET_DETAIL_CLIENT: {
            return {
                ...state,
                detailClient: action.payload
            };
        }
        case ACTIONS.SET_NEW_DETAIL_CLIENT: {
            return {
                ...state,
                newDetailClient: action.payload
            };
        }
        case ACTIONS.SET_ERROR: {
            return {
                ...state,
                errorFetch: action.payload
            };
        }
        case ACTIONS.SET_ALL_REGION: {
            return {
                ...state,
                allRegion: action.payload
            };
        }
        case ACTIONS.SET_ID_REGION: {
            return {
                ...state,
                idRegion: action.payload
            };
        }
        case ACTIONS.SET_ALL_TYPE_ELECTRODEPENDIENTES: {
            return {
                ...state,
                allTypelectrodependientes: action.payload
            };
        }
        case ACTIONS.SET_COMUNA: {
            return {
                ...state,
                comuna: action.payload
            };
        }
        case ACTIONS.SET_COMUNA_REGION: {
            return {
                ...state,
                comunaRegion: action.payload
            };
        }
        case ACTIONS.SET_WEB_CONTENT_TERMS: {
            return {
                ...state,
                webContentTerm: action.payload
            };
        }
        case ACTIONS.SET_JSON_FORMS: {
            return {
                ...state,
                jsonForms: action.payload
            };
        }
        case ACTIONS.SET_JSON_FORMSRE: {
            return {
                ...state,
                jsonFormsRe: action.payload
            };
        }
        case ACTIONS.SET_JSON_FORMSBA: {
            return {
                ...state,
                jsonFormsBa: action.payload
            };
        }
        case ACTIONS.SET_JSON_FORMSCD: {
            return {
                ...state,
                jsonFormsCd: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_FORMS: {
            return {
                ...state,
                responseForms: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_FORMSRE: {
            return {
                ...state,
                responseFormsRe: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_FORMSBA: {
            return {
                ...state,
                responseFormsBa: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_FORMSCD: {
            return {
                ...state,
                responseFormsCd: action.payload
            };
        }
        case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
            return {
                ...state,
                webContentTextInfo: action.payload,
            };
        }
        case ACTIONS.SET_FECHA_SOLICITUD: {
            return {
                ...state,
                fechaSolicitud: action.payload,
            };
        }
        case ACTIONS.SET_SOLICITUDED: {
            return {
                ...state,
                solicitudED: action.payload,
            };
        }
        case ACTIONS.SET_EQUIPOS: {
            return {
                ...state,
                equipos: action.payload,
            };
        }
        default: {
            return state;
        }
    }

};

const ElectrodependentContextProvider = ({ children }) => {
    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useReducer(ElectrodependentReducer, initialState)

    React.useEffect(() => {
        if (state.loadPage) {
            LiferayService.getAllRegions(properties.base_url_api)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_ALL_REGION,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })

            LiferayService.getAllComunas(properties.base_url_api)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_COMUNA,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })

            LiferayService.allTipoTlectrodependientes(properties.base_url_api)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_ALL_TYPE_ELECTRODEPENDIENTES,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })

            LiferayService.getWebContent(properties.base_url_api, properties.web_content_terms_electrodependent)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_WEB_CONTENT_TERMS,
                    });
                })
            if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
                LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
                    .then((response) => {
                        dispatch({
                            payload: response,
                            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
                        });
                    })
            }
        }

    }, [state.loadPage])

    React.useEffect(() => {
        if (state.idClient && state.rutPatient) {
            dispatch({
                type: ACTIONS.SET_IDCLIENT_AUX,
                payload: state.idClient
            });
            LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.idClient, properties.url_ws_empresa, properties.codigo_empresa)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_DETAIL_CLIENT,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                    dispatch({
                        type: ACTIONS.SET_IDCLIENT,
                        payload: ""
                    });
                    setTimeout(() => {
                        if (response.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                            LiferayService.consultarEstadoSolicitudED(properties.base_url_api, state.idClient, state.rutPatient)
                                .then((estadoSolicitudResponse) => {
                                    console.log("Estado solicitud ED:", estadoSolicitudResponse);
                                    dispatch({
                                        payload: estadoSolicitudResponse,
                                        type: ACTIONS.SET_SOLICITUDED,
                                    });
                                    dispatch({
                                        payload: estadoSolicitudResponse.listaEquipos,
                                        type: ACTIONS.SET_EQUIPOS,
                                    });
                                    dispatch({
                                        payload: estadoSolicitudResponse.fechaSolicitud,
                                        type: ACTIONS.SET_FECHA_SOLICITUD,
                                    });
                                    dispatch({
                                        type: ACTIONS.SET_RUT,
                                        payload: ""
                                    });
                                })
                        }
                    }, 500);
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.idClient])

    React.useEffect(() => {
        if (state.idRegion) {
            LiferayService.getComunasFromRegion(properties.base_url_api, state.idRegion)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_COMUNA_REGION,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.idRegion])

    React.useEffect(() => {
        if (state.newIdClient) {
            LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.newIdClient, properties.url_ws_empresa, properties.codigo_empresa)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_NEW_DETAIL_CLIENT,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                    dispatch({
                        type: ACTIONS.SET_NEWIDCLIENT,
                        payload: ""
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.newIdClient])

    React.useEffect(() => {
        if (state.jsonForms) {
            LiferayService.electrodependiente(properties.base_url_api, state.jsonForms[0], state.jsonForms[1])
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_FORMS,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.jsonForms])

    React.useEffect(() => {
        if (state.jsonFormsRe) {
            LiferayService.electrodependienteRenovacion(properties.base_url_api, state.jsonFormsRe[0], state.jsonFormsRe[1])
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_FORMSRE,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.jsonFormsRe])

    React.useEffect(() => {
        if (state.jsonFormsBa) {
            LiferayService.electrodependienteBaja(properties.base_url_api, state.jsonFormsBa[0], state.jsonFormsBa[1])
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_FORMSBA,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.jsonFormsBa])

    React.useEffect(() => {
        if (state.jsonFormsCd) {
            LiferayService.electrodependienteCambioDomicilio(properties.base_url_api, state.jsonFormsCd[0], state.jsonFormsCd[1])
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_FORMSCD,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                })
        }
    }, [state.jsonFormsCd])

    return (
        <ElectrodependentContext.Provider value={[state, dispatch]}>
            {children}
        </ElectrodependentContext.Provider>

    )
}

export default ElectrodependentContextProvider;